import { useEffect, useState } from "react";
import { categoryOf } from "./FileCard";

/**
 * FileThumb — compact file preview. Image files render a real thumbnail via the
 * /raw redirect (raster-only allowlist, never an SVG); everything else gets a
 * per-category doc icon. Broken image loads fall back to the icon. Shared by the
 * Files grid cards and the list-view table so the two never diverge.
 */
function DocIcon() {
  return (
    <svg className="ficon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M5 3.5h6l4 4v9a1 1 0 01-1 1H5a1 1 0 01-1-1v-12a1 1 0 011-1z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M11 3.5V7.5h4"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileThumb({
  id,
  ext,
  size = 32,
}: {
  id: string;
  ext: string;
  size?: number;
}) {
  const cat = categoryOf(ext);
  const [broken, setBroken] = useState(false);
  // A re-uploaded file keeps the same id, but reset defensively if id changes.
  useEffect(() => setBroken(false), [id]);
  const showImg = cat === "img" && !broken;

  return (
    <span
      className={`file-thumb file-thumb-${cat}`}
      style={{ width: size, height: size }}
    >
      {showImg ? (
        <img
          src={`/api/attachments/${id}/raw`}
          alt=""
          loading="lazy"
          onError={() => setBroken(true)}
        />
      ) : (
        <>
          <DocIcon />
          <span className="file-thumb-ext t-mono">{ext || "?"}</span>
        </>
      )}
    </span>
  );
}
